import { Message } from 'element-ui';
import store from '@/store';
import common from '@/filters/index.js';
import { autoNumber } from '@/filters/filters.js';
import tools from '@/common'
import { rateCoin } from "@/config";
import _ from "loadsh";

// 全局函数
export default {
    install(Vue, options) {
        Vue.prototype.$common = common;
        Vue.prototype.$tools = tools;
        Vue.prototype.$store = store;
        // 涨跌幅颜色
        Vue.prototype.tickersColor = function(val, type) {
            let red = ' font_red',
                green = ' font_green',
                common = ' iconfont ',
                up = common + ' icon-arrowup icon-long_arrow_up',
                down = common + ' icon-arrowdown icon-long_arrow_down';

            if (val >= 0) {
                return type ? green + '' + up : green;
            } else if ((val < 0)) {
                return type ? red + '' + down : red;
            }
        };

        // 复制内容
        Vue.prototype.copy = function(e) {
            let o = document.createElement("textarea");
            let n;
            o.value = e,
                o.style.position = "absolute",
                o.style.top = -1e4,
                o.style.left = -1e4,
                document.body.appendChild(o),
                o.select();
            try {
                n = document.execCommand("copy");
            } catch (e) {

            }
            document.body.removeChild(o);
            if (n) {
                Message.success(this.$t('main.copySuccess'))
            } else {
                Message.error('浏览器不支持，请手动复制！')
            }
        }

        // 获取币种图标
        Vue.prototype.getCoinIcon = function(coin) {
            if (!coin) return;
            let coins = store.state.coins;

            if (coins[coin] && coins[coin].logo) {
                return coins[coin].logo;
            } else if (coin == 'favicon') {
                return store.state.favicon;
            } else {
                return '/static/assets/coins/' + coin.toLowerCase() + '.png'
            }

        };
        // 获取币种符号
        Vue.prototype.symbol = function(amount = 0, coin = "") {
            let symbol = null;
            let text = null;
            // 取符号 
            switch (coin) {
                case 'USD':
                case 'USDT':
                    symbol = '$';
                    break;
                case "CNY":
                    symbol = '¥';
                    break;
            }
            if (!symbol) {
                text = `${amount} ${coin}`
            } else {
                text = `${symbol} ${amount}`
            }
            return text;
        };
        // 获取估值
        Vue.prototype.getValuation = function(amount = 0, row = {}) {
            let symbol = ""; //符号
            let rate = 0; //汇率 
            let price = 0; //估值 

            const keyArr = _.keys(row) || []; //将key转换成数组
            let lowCoin = rateCoin.toLowerCase() //转换成小写
            const rateNames = [lowCoin + 'Rate', lowCoin + 'Price']

            // 取汇率
            rateNames.map((item, i) => {
                    if (keyArr.indexOf(item) != -1) {
                        rate = row[item];
                    }
                })
                // 取符号 
            switch (rateCoin) {
                case 'USD':
                    symbol = '$';
                    break;
                case "CNY":
                    symbol = '¥';
                    break;
            }

            // 当没有传汇率的时候是后端计算好的数据，直接返回
            if (keyArr.length == 0) {
                price = amount
            } else {
                price = autoNumber(amount * rate);
            }

            return '≈ ' + symbol + ' ' + price;
        };
    }
};


// WEBPACK FOOTER //
// ./src/common/base.js